<div class="notifications-panel">
  <div class="notifications-panel-header">
    <div class="notifications-panel-title">
      <div class="notifications-panel-bell-wrapper">
        <img class="notifications-bell-icon" src="assets/image/home/icon-notification-bell.svg" alt="">
        <span *ngIf="notificationCount > 0" class="notifications-panel-badge" [class.notifications-panel-badge--vendedor]="badgeVariant === 'vendedor'" [class.notifications-panel-badge--single]="notificationCount < 10">{{ badgeLabel }}</span>
      </div>
      <span class="notifications-panel-title-text">{{ notificationTitle }}</span>
    </div>
    <button type="button" class="notifications-close-btn" aria-label="Cerrar" (click)="close()">
      <img src="assets/image/home/notification-close.svg" alt="" width="24" height="24">
    </button>
  </div>
  <div class="notifications-chips" *ngIf="badgeVariant === 'cliente'">
    <button type="button" class="notification-chip" [class.active]="notificationFilter === 'all'" (click)="setFilter('all')">Todas</button>
    <button type="button" class="notification-chip" [class.active]="notificationFilter === 'pedidos'" (click)="setFilter('pedidos')">Pedidos</button>
    <button type="button" class="notification-chip" [class.active]="notificationFilter === 'promociones'" (click)="setFilter('promociones')">Promociones</button>
    <button type="button" class="notification-chip" [class.active]="notificationFilter === 'aliados'" (click)="setFilter('aliados')">Aliados Beneficios</button>
    <button type="button" class="notification-chip" [class.active]="notificationFilter === 'cuenta'" (click)="setFilter('cuenta')">Cuenta corriente</button>
    <button type="button" class="notification-chip" [class.active]="notificationFilter === 'reclamos'" (click)="setFilter('reclamos')">Mis reclamos</button>
    <button type="button" class="notification-chip" [class.active]="notificationFilter === 'novedades'" (click)="setFilter('novedades')">Novedades</button>
  </div>
  <div class="notifications-chips" *ngIf="badgeVariant === 'vendedor'">
    <button type="button" class="notification-chip" [class.active]="notificationFilter === 'all'" (click)="setFilter('all')">Todas</button>
    <button type="button" class="notification-chip" [class.active]="notificationFilter === 'alicorp-way'" (click)="setFilter('alicorp-way')">Alicorp Way</button>
    <button type="button" class="notification-chip" [class.active]="notificationFilter === 'promociones'" (click)="setFilter('promociones')">Promociones</button>
    <button type="button" class="notification-chip" [class.active]="notificationFilter === 'novedades-avisos'" (click)="setFilter('novedades-avisos')">Novedades y avisos</button>
  </div>
  <div class="notifications-list" *ngIf="!hasError; else notificationsError">
    <ng-container *ngIf="notifications && notifications.length > 0; else notificationsEmpty">
      <ng-container *ngIf="filteredNotifications && filteredNotifications.length > 0; else notificationsSectionEmpty">
        <div class="notification-card" *ngFor="let item of filteredNotifications"
          [class.notification-card--clickable]="!hasNotificationUrl(item)"
          (click)="!hasNotificationUrl(item) && onCardClick(item, $event)">
          <div class="notification-card-header">
            <span class="notification-tag" [attr.data-section]="item.section?.toLowerCase()">{{ item.section }}</span>
            <span class="notification-dot" [class.notification-dot--read]="item.read" [class.notification-dot--vendedor]="badgeVariant === 'vendedor'"></span>
          </div>

          <div *ngIf="hasOrderStatusBlock(item)" class="notification-order-status">
            <div class="order-timeline" aria-hidden="true">
              <!-- Fila 1: círculos + conectores (cada col = 24px, conectores = fill) -->
              <div class="order-timeline__circles-row">
                <ng-container *ngFor="let step of orderTimelineSteps; let i = index; let last = last">
                  <div class="order-timeline__circle-wrap">
                    <div class="order-timeline__circle"
                      [class.order-timeline__circle--future]="isOrderTimelineFutureStep(item, i)">
                      <img *ngIf="!isOrderTimelineFutureStep(item, i)" class="order-timeline__step-icon" src="assets/svg/step.svg" width="24" height="24" alt="">
                      <span *ngIf="isOrderTimelineFutureStep(item, i)" class="order-timeline__step-num">{{ i + 1 }}</span>
                    </div>
                  </div>
                  <div *ngIf="!last" class="order-timeline__connector"
                    [class.order-timeline__connector--done]="isOrderTimelineConnectorDone(item, i)"></div>
                </ng-container>
              </div>
              <!-- Fila 2: etiquetas alineadas con sus círculos (mismas proporciones que fila 1) -->
              <div class="order-timeline__labels-row">
                <ng-container *ngFor="let step of orderTimelineSteps; let i = index; let last = last">
                  <div class="order-timeline__label-col"
                    [class.order-timeline__label-col--first]="i === 0"
                    [class.order-timeline__label-col--last]="last">
                    <span class="order-timeline__label"
                      [class.order-timeline__label--active]="isOrderTimelineStepLabelActive(item, i)">{{ step.label }}</span>
                  </div>
                  <div *ngIf="!last" class="order-timeline__label-spacer"></div>
                </ng-container>
              </div>
            </div>
          </div>

          <h3 class="notification-card-title">{{ item.title }}</h3>
          <p class="notification-card-body">{{ item.message }}</p>
          <div class="notification-card-footer">
            <span class="notification-card-date" *ngIf="item.startAt">{{ formatDateFromStartAt(item.startAt) }}</span>
            <button *ngIf="hasNotificationUrl(item)" type="button" class="notification-card-btn-details" (click)="markAsReadAndOpenDetail(item)">
              <span>Ver detalles</span>
              <img src="assets/image/home/notification-arrow.svg" alt="" width="16" height="16">
            </button>
          </div>
        </div>
        <div class="notifications-auto-retire">
          <div class="notifications-auto-retire-icon">
            <img src="assets/image/home/time.svg" alt="" width="24" height="24">
          </div>
          <p class="notifications-auto-retire-text">Las notificaciones se retiran<br>automáticamente con el tiempo.</p>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <ng-template #notificationsEmpty>
    <div class="notifications-empty-container">
      <div class="notifications-empty-card">
        <p class="notifications-empty-emoji">📭</p>
        <p class="notifications-empty-title">
          Aún no tienes notificaciones
        </p>
        <p class="notifications-empty-message">
          Cuando haya novedades, las verás aquí.
        </p>
      </div>
    </div>
  </ng-template>

  <ng-template #notificationsSectionEmpty>
    <div class="notifications-section-empty-container">
      <div class="notifications-section-empty-card">
        <p class="notifications-section-empty-emoji">📭</p>
        <p class="notifications-section-empty-title">
          No tienes notificaciones en esta sección
        </p>
        <p class="notifications-section-empty-message">
          Cuando tengas novedades aquí, te avisaremos.
        </p>
      </div>
    </div>
  </ng-template>

  <ng-template #notificationsError>
    <div class="notifications-error-container">
      <div class="notifications-error-card">
        <p class="notifications-error-title">
          Algo salió mal
        </p>
        <p class="notifications-error-message">
          Lo sentimos, no pudimos mostrar tus notificaciones vuelve a intentarlo en unos minutos.
        </p>
        <div class="notifications-error-actions">
          <button type="button" class="notifications-error-retry-btn" (click)="onRetry()">
            <span>Reintentar</span>
            <img src="assets/image/home/restart-icon.svg" alt="" width="16" height="16" />
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
